import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo_png from '../Logo_png';
import Modal from './Modal';
import Login from './Login';
import Register from './Register';
import UserLoggedInIcon from '../UserLoggedInIcon';
import { useUser } from './UserContext';
import HamburgerMenu from './HamburgerMenu';
import { useCart } from '../components/CartContext';
import CartIcon from './CartIcon';
import { LICENCJA_PAGES } from '../seo/siteMeta';
import styles from '../css/modules/Header.module.css';
import modalStyles from '../css/modules/Modal.module.css';

const Header = () => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const { user, logout } = useUser();
  const { cartItems } = useCart();

  const switchToRegister = () => {
    setIsLoginModalOpen(false);
    setIsRegisterModalOpen(true);
  };

  return (
    <header className={styles.headerBackground}>
      <div className={styles.logoContainer}>
        <Link to="/" aria-label="Pilotuje.pl - strona główna">
          <Logo_png size="100px" />
        </Link>
      </div>

      {/* Nawigacja w zwykłych linkach - czytelna dla robotów i bez JS */}
      <nav className={styles.mainNav} aria-label="Nawigacja główna">
        {LICENCJA_PAGES.map(p => (
          <Link key={p.path} to={p.path}>{p.krotko}</Link>
        ))}
        <a href="/poradnik">Poradnik</a>
        <Link to="/cennik">Cennik</Link>
      </nav>

      <div className={styles.rightContainer}>
        <Link to="/intro" className={styles.navCta}>
          Darmowy test
        </Link>
        <div className={styles.navItems}>
          {user ? (
            <>
              <span className={styles.greeting}>
                Witaj, {user.name || 'Pilocie'}!
              </span>
              <button onClick={logout} className={styles.logoutButton}>
                Wyloguj
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => setIsLoginModalOpen(true)}
                className={styles.authButton}
              >
                Logowanie
              </button>
              <Modal
                isOpen={isLoginModalOpen}
                onClose={() => setIsLoginModalOpen(false)}
                ariaLabel="Logowanie"
              >
                <Login
                  closeModal={() => setIsLoginModalOpen(false)}
                  switchToRegister={switchToRegister}
                />
              </Modal>
              {/* <button
                onClick={() => setIsRegisterModalOpen(true)}
                className={styles.authButton}
              >
                Rejestracja
              </button> */}
              <Modal
                isOpen={isRegisterModalOpen}
                onClose={() => setIsRegisterModalOpen(false)}
                extraClass={modalStyles.regModalContent}
                ariaLabel="Rejestracja"
              >
                <Register closeModal={() => setIsRegisterModalOpen(false)} />
              </Modal>
            </>
          )}
          {/* Wyświetlenie ikony koszyka, gdy w koszyku są produkty */}
          {cartItems.length > 0 && <CartIcon />}
        </div>
        <div className={styles.hamburgerContainer}>
          <HamburgerMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;
